//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default { 
  components: { 
    
  },
  data (){
    return {
      total_ktp:'',

      total_kk1:'',
      total_kk2:'',
      total_kk3:'',
      total_ppd1:'',
      total_ppd2:'',
      total_ppd3:'',
      total_lahir:'',
      total_lahir_aytdau:'',
      total_lahir_mati:'',
      total_mati:'',

      value :100  ,
      slide: 'style',
      transitions: [ 
        'jump-up',
 
      ],

      list_tampung : [],



      list_data : [
        {
          nama : 'Indra',
          alamat : [
            {
              jalan1 : "Kota Lama",
              jalan2 : "xxxxxxx-1",
            },
            {
              jalan1 : "Pasar Baru",
              jalan2 : "xxxxxxx-2",
            },
            {
              jalan1 : "Neraka",
              jalan2 : "xxxxxxx-3",
            },
          ]
        },

        {
          nama : 'Iksan',
          alamat : [
            {
              jalan1 : "Lumpur Lapindo",
              jalan2 : "xxxxxxx-4",
            },
            {
              jalan1 : "Neraka Jahanam",
              jalan2 : "xxxxxxx-5",
            },
            {
              jalan1 : "Toilet",
              jalan2 : "xxxxxxx-6",
            },
          ]
        },

        {
          nama : 'Fajar',
          alamat : [
            {
              jalan1 : "Pantat Sapi",
              jalan2 : "xxxxxxx-7",
            },
            {
              jalan1 : "Mulut Buaya",
              jalan2 : "xxxxxxx-8",
            },
            {
              jalan1 : "Tai Kambing",
              jalan2 : "xxxxxxx-9",
            },
          ]
        },
       
        

      ]

    }
  },

// URL_DASHBOARD
  methods: {
    ViewKTP : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "ktp", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_ktp = res_data[0]; 
      });
    },

    ViewKK1 : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "kk1", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_kk1 = res_data[0]; 
      });
    },
    ViewKK2 : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "kk2", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_kk2 = res_data[0]; 
              // console.log(res_data[0]);
      });
    },
    ViewKK3 : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "kk3", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_kk3 = res_data[0]; 
      });
    }, 
 
    ViewPPD1 : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "ppd1", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_ppd1 = res_data[0]; 
      });
    }, 
    ViewPPD2 : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "ppd2", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_ppd2 = res_data[0]; 
      });
    }, 
    ViewPPD3 : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "ppd3", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_ppd3 = res_data[0]; 
      });
    }, 
    Viewtotal_lahir : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "lahir", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_lahir = res_data[0]; 
      });
    }, 
    Viewtotal_lahir_aytdau : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "lahir_aytdau", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_lahir_aytdau = res_data[0]; 
      });
    }, 

    ViewLahirMati : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "lahir_mati", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_lahir_mati = res_data[0]; 
      });
    }, 
    ViewMati : function(){ 
      fetch(this.$store.state.url.URL_DASHBOARD + "mati", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }, 
        })
          .then(res => res.json())
          .then(res_data => { 
              this.total_mati = res_data[0]; 
      });
    }, 
    

  },
  mounted () {
    // this.tes()
    this.ViewKTP();
    this.ViewKK1();
    this.ViewKK2();
    this.ViewKK3();
    this.ViewPPD1();
    this.ViewPPD2();
    this.ViewPPD3();
    this.Viewtotal_lahir();
    this.Viewtotal_lahir_aytdau();
    this.ViewLahirMati();
    this.ViewMati();
  },
}
